export const UPDATE = "apps/UPDATE";
export const APPEND = "apps/APPEND";
export const UPDATE_ONE = "apps/UPDATE_ONE";
export const DESTROY = "apps/DESTROY";
export const LOADING = "apps/LOADING";
export const SET_SELECTED = "apps/SET_SELECTED";